var React = require('react');

function ArrowUpSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 9L13 5L16 9H10Z","fill":"#181818"}));
}

ArrowUpSmall.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowUpSmall;

ArrowUpSmall.default = ArrowUpSmall;
